import React from "react";
import { Auth } from "aws-amplify";
import { FcGoogle } from "react-icons/fc";
import { FaFacebookF } from "react-icons/fa";

// Federated sign-in via Cognito's OAuth bridge to Google / Facebook.
// Skips the Hosted UI form entirely — passing `provider` causes Cognito
// to redirect straight to the provider's consent screen.
//
// After consent → Cognito callback → frontend origin with `?code=`.
// Amplify exchanges the code, emits the `signIn` Hub event, and ZAuth
// refreshes the user.
const verbMap = {
  login: "Masuk",
  signup: "Daftar",
};

export default function SocialButtons({ mode = "login" }) {
  const verb = verbMap[mode] || "Lanjut";

  const handler = (provider) => () => {
    try {
      Auth.federatedSignIn({ provider });
    } catch (_) {
      // Amplify throws synchronously only on config errors; the actual
      // redirect happens via window.location and never returns.
    }
  };

  return (
    <div className="auth__social">
      <button
        type="button"
        className="auth__social-btn auth__social-btn--google"
        onClick={handler("Google")}
      >
        <FcGoogle size="1.3em" />
        <span>{verb} dengan Google</span>
      </button>
      <button
        type="button"
        className="auth__social-btn auth__social-btn--facebook"
        onClick={handler("Facebook")}
      >
        <FaFacebookF size="1em" />
        <span>{verb} dengan Facebook</span>
      </button>
    </div>
  );
}
